module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"linktogame":"Links to simulation","close":"Close"},"fi":{"linktogame":"Linkit simulaatioon","close":"Sulje"},"sv":{"linktogame":"Länkar till simulering","close":"Stäng"},"de":{"linktogame":"Links zur Simulation","close":"Schließen"},"ko":{"linktogame":"시뮬레이션 링크","close":"닫기"}}')
  delete Component.options._Ctor
}
